import React from "react";
import Header from "./Header";
import Dashboard from "./Dashboard";
import VideoPlay from "./VideoPlay";
import Divider from '@mui/material/Divider';
import Grid  from "@mui/material/Grid";

const VideoDisplay = () => {
    return (
      <>
        <Header />
        <Grid container p={1}>
          <Grid item xs={1.5}></Grid>
          <Grid item xs={9}>
            <VideoPlay />
            <Divider color="#D8D8D8" />
            <Dashboard
              genre={["All"]}
              rating={["Any"]}
              sortBy={"Release Date"}
              search={null}
            />
          </Grid>
          <Grid item xs={1.5}></Grid>
        </Grid>
        
      </>
    );
}

export default VideoDisplay